import React, { useState, useEffect } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

//import useDidMountEffect from 'pages/parts/useDidMountEffect'
import { POST } from 'helpers/api'

function TableControl({ modalTableControl, setModalTableControl, keyName }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const reduxSettings = useSelector(state => state.settings)

	//const [selectedTable, setSelectedTable] = useState({})
	const [settings, setSettings] = useState({
		'size': 20,
		'decimalPoint': 2,
		'currencyId': "",
		'posId': "",
		'organizationId': "",
		'rememberLastDocumentInPreview': null,
		'tableNomenclature': {
			'posName': true,
			'organizationName': true,
			'gtin': true,
			'wholesalePrice': true,
			'bankPrice': false,
			'currencyName': true,
			'serial': true,
			'expDate': true,
			'balance': true,
			'artikul': false,
			'categoryName': false,
			'pos': true,
			'vat': true,
		},
		'tableRevaluation': {
			'artikul': false,
			'pos': true,
			'bankPrice': false,
			'categoryName': false,
		},
		'tableHistory': {
			'artikul': false,
			'pos': true,
			'bankPrice': false,
			'categoryName': false,
		},
		'tableScale': {
			'artikul': false,
			'pos': true,
		},
		'tableGrouping': {
			'pos': true,
		},
		'tableNotfications': {
			'artikul': false,
			'pos': true,
		},
		'tableReport': {
			'change': true,
			'discount': true,
			'ugetPaid': true,
			'ugetBonus': true,
			'debtIn': true,
			'expenseAmount': true,
			'returnedAmount': true,
			'click': true,
			'payme': true,
		},
		'tableDocumentsInCreate': {
			'uomName': true,
			'packQuantity': false,
			'wholesalePrice': true,
			'serial': true,
			'expDate': true,
			'vat': true,
			'artikul': false,
			'originalPrice': false,
			'bankPrice': false,
			'marking': false,
		},
		'tableDocumentsInPreview': {
			'serial': true,
			'expDate': true,
			'wholesalePrice': true,
			'vat': true,
			'artikul': false,
			'originalPrice': false,
			'bankPrice': false,
			'marking': false,
		},
		'tableReportIncomes': {
			'currencyName': true,
			'vat': true,
			'vatAmount': true,
			'artikul': false,
			'pos': true,
			'bankPrice': false,
			'expense': false,
			'transfer': false,
			'categoryName': false,
		},
		'tableTransfer': {
			'serial': true,
			'expDate': true,
			'wholesalePrice': true,
			'vat': true,
			'artikul': false,
			'bankPrice': false,
			'categoryName': false,
		},
		'tableReportSales': {
			'agent': true,
			'cashier': true,
			'currencyName': true,
			'discount': true,
			'artikul': true,
			'categoryName': true,
		},
		'tableReportExpirationDate': {
			'artikul': true,
			'categoryName': false,
		},
		'tableReportReturnProducts': {
			'artikul': true,
			'categoryName': false,
		},
		'tableReportGrossIncome': {
			'artikul': true,
			'categoryName': false,
		},
		'tableReportCategoryManagment': {
			'artikul': true,
			'categoryName': false,
		},
	})

	const fieldsConfig = [
		{ name: "wholesalePrice", label: t("WHOLESALE_PRICE") },
		{ name: "currencyName", label: t("CURRENCY") },
		{ name: "gtin", label: t("IKPU") },
		{ name: "packQuantity", label: t("PACKAGE_QUANTITY") },
		{ name: "serial", label: t("SERIAL") },
		{ name: "expDate", label: t("EXPIRATION_DATE") },
		{ name: "vat", label: t("VAT") },
		{ name: "vatAmount", label: `${t("AMOUNT")} ${t("VAT")}` },
		{ name: "cashier", label: t("CASHIER") },
		{ name: "agent", label: t("AGENT") },
		{ name: "artikul", label: t("ARTIKUL") },
		{ name: "categoryName", label: t("CATEGORY") },
		{ name: "originalPrice", label: t("ORIGINAL_PRICE") },
		{ name: "change", label: t("CHANGE") },
		{ name: "bankPrice", label: t("BANK_PRICE") },
		{ name: "marking", label: t("MARKING") },
		{ name: "pos", label: t("POS") },
		{ name: "expense", label: t("EXPENSES") },
		{ name: "transfer", label: t("DISPLACEMENT") },
		{ name: "discount", label: t('DISCOUNT') },
		{ name: "ugetPaid", label: t("PAYMENT_2") },
		{ name: "ugetBonus", label: t("BONUS") },
		{ name: "debtIn", label: t("DEBT_RETURNED") },
		{ name: "expenseAmount", label: t("OUT_BALANCE") },
		{ name: "returnedAmount", label: t("RETURN") },
		{ name: "click", label: t("CLICK") },
		{ name: "payme", label: t("PAYME") },

	]


	function handleChange(e) {
		var settingsCopy = { ...settings }
		settingsCopy[keyName][e.target.name] = e.target.checked
		setSettings(settingsCopy)
	}

	async function saveSettings() {
		var sendData = {
			'settings': JSON.stringify(settings)
		}
		const response = await POST("/services/web/api/user-settings", sendData, { loader: true })
		if (response) {
			dispatch({ type: 'SET_SETTINGS', payload: settings })
			setSettings(settings)
			setModalTableControl(false)
		}
	}

	useEffect(() => {
		if (
			settings &&
			reduxSettings &&
			Object.keys(settings).length === Object.keys(reduxSettings).length) {
			setSettings(reduxSettings)
		} else {
			for (var key in settings) {
				if (reduxSettings.hasOwnProperty(key)) { //IF OBJECT HAVE ALL KEYS
					if (
						settings[key] &&
						reduxSettings[key] &&
						Object.keys(settings[key]).length !== Object.keys(reduxSettings[key]).length
					) { //IF OBJECT OF OBJECT HAVE ALL KEYS

						for (var tableKey in settings[key]) {
							// if (reduxSettings[key].hasOwnProperty(tableKey)) {
							reduxSettings[key][tableKey] = settings[key][tableKey]
							// }
						}
						if (Object.keys(settings[key]).length < Object.keys(reduxSettings[key]).length) {
							for (tableKey in reduxSettings[key]) {
								if (!settings[key].hasOwnProperty(tableKey)) {
									if (tableKey !== '0') {
										delete reduxSettings[key][tableKey]
									}
								}
							}
						}
					}
					// if (Object.keys(reduxSettings[key])?.length > Object.keys(settings[key])?.length) {
					// 	console.log(reduxSettings[key]);
					// }
				} else {
					reduxSettings[key] = settings[key]
				}
			}
		}
		setSettings(reduxSettings)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	// useDidMountEffect(() => {
	// 	setSettings(reduxSettings)
	// }, [reduxSettings]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL TABLE CONTROL */}
			<Modal show={modalTableControl} animation={false} centered size="sm" onHide={() => setModalTableControl(false)}>
				<Modal.Body>
					{fieldsConfig.map(field => {
						const isVisible = settings[keyName] && typeof settings[keyName][field.name] === "boolean"
						if (!isVisible) return null

						return (
							<div key={field.name} className="d-flex justify-content-between mb-2">
								<div className="vertical-center">{field.label}</div>
								<div className="vertical-center">
									<input
										type="checkbox"
										name={field.name}
										onChange={handleChange}
										checked={settings[keyName][field.name]}
									/>
								</div>
							</div>
						)
					})}

					<div className="d-flex justify-content-center w-100 mt-3">
						<button className="btn-sm btn-primary w-50" onClick={saveSettings}>
							{t("SAVE")}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TABLE CONTROL */}
		</>
	)
}

export default TableControl